"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSearchHistory = void 0;
var _logger = require("@ori/logger");
var _react = require("react");
var _useLocalStorageState = _interopRequireDefault(require("use-local-storage-state"));
var _types = require("../types");
const DEFAULT_VERSION = '1.0.0';
const DEFAULT_KEY = 'search_history';
const DEFAULT_MAX_ITEMS = 10;
const useSearchHistory = ({
  key = DEFAULT_KEY,
  version = DEFAULT_VERSION,
  maxItems = DEFAULT_MAX_ITEMS
} = {}) => {
  const logger = (0, _logger.useLogger)('useSearchHistory');
  const [snapshot, setSnapshot, {
    removeItem: removeStorageItem
  }] = (0, _useLocalStorageState.default)(key, {
    defaultValue: {
      version,
      items: []
    },
    serializer: {
      stringify: JSON.stringify,
      parse: value => {
        try {
          const validated = _types.SearchHistorySnapshotSchema.parse(JSON.parse(value));
          if (validated.version !== version) {
            logger.warn('Search history version mismatch, resetting to default');
            return {
              version,
              items: []
            };
          }
          const sorted = validated.items.sort((a, b) => b.timestamp - a.timestamp);
          return {
            version: validated.version,
            items: sorted
          };
        } catch (error) {
          logger.error(new Error('Failed to parse search history from local storage, resetting to default', {
            cause: error
          }));
          return {
            version,
            items: []
          };
        }
      }
    }
  });
  const addSearchItem = (0, _react.useCallback)((text, url) => {
    try {
      const filtered = snapshot.items.filter(item => item.text !== text);
      const newItem = {
        text,
        url,
        timestamp: Date.now()
      };
      const updated = [newItem, ...filtered].slice(0, maxItems);
      setSnapshot({
        version,
        items: updated
      });
    } catch (error) {
      logger.warn('Failed to save search history item');
    }
  }, [snapshot.items, maxItems, version, setSnapshot, logger]);
  const clearHistory = (0, _react.useCallback)(() => {
    removeStorageItem();
  }, [removeStorageItem]);
  const removeItem = (0, _react.useCallback)(text => {
    try {
      const updated = snapshot.items.filter(item => item.text !== text);
      setSnapshot({
        version,
        items: updated
      });
    } catch {
      logger.warn('Failed to remove search history item');
    }
  }, [snapshot.items, version, setSnapshot, logger]);
  const popSearchItem = (0, _react.useCallback)(() => {
    try {
      const [latest, ...rest] = snapshot.items;
      if (!latest) {
        return null;
      }
      setSnapshot({
        version,
        items: rest
      });
      return latest;
    } catch {
      logger.warn('Failed to pop search history item');
      return null;
    }
  }, [snapshot.items, version, setSnapshot, logger]);
  return {
    items: snapshot.items,
    addSearchItem,
    clearHistory,
    removeItem,
    popSearchItem
  };
};
exports.useSearchHistory = useSearchHistory;
